const initialState = window.init_data;
const initList = (initialState && initialState[2] && initialState[2].list) || [];
export default function ads(state = initList, action) {
  // console.log(state)
  return state;
}